import {useMemo} from 'react'
import {GiftShopContentData, UserData} from 'types'

export function useTransactionDetailBuySellHooks(
  data: GiftShopContentData[],
  user: UserData,
) {
  const isFirstBuy =
    data && data.findIndex((item) => item.is_free_first_buy) !== -1
  const findHost =
    data &&
    data.map((item) => item.tags.findIndex((tag) => tag.type === 'host') !== -1)
  const isHost = findHost && findHost.findIndex((item) => item === true) !== -1
  const {id: selfId, nickname} = user
  const isSelf =
    data && data.map((dt) => dt.member_id === selfId).includes(true)
  const userBuysTheirOwnContent =
    isSelf &&
    data &&
    data.map((dt) => dt.collector_nickname === nickname).includes(true)

  return useMemo(
    () => ({
      isFirstBuy,
      isHost,
      isSelf,
      userBuysTheirOwnContent,
    }),
    [isFirstBuy, isHost, isSelf, userBuysTheirOwnContent],
  )
}
